const getDefaultSteps = () => {
  const step1 = {
    index: 1,
    valid: false,
    title: 'Comprobante',
    subtitle: 'Datos del comprobante',
    component: formulario => {
      const UnknownForm = {
        render() {
          return <div>Formulario no disponible por el momento.</div>
        },
      }
      return formulario.component || UnknownForm
    },
    stepData: null,
  }
  const step2 = {
    index: 2,
    valid: false,
    title: 'Modo de pago',
    subtitle: 'Selección del modo de pago',
    component: () => require('@/components/Formularios/ModoPagoStep').default,
    stepData: null,
  }
  step1.next = step2
  step2.next = null
  return [step1, step2]
}

const getDefaultState = () => {
  return {
    steps: getDefaultSteps(),
    currentStep: null,
    formulario: null,
    altaDeudaRequest: {},
  }
}

const state = getDefaultState()

// mutations
const mutations = {
  nextStep(state) {
    state.currentStep = state.currentStep.next
  },
  setCurrentStep(state, step) {
    state.currentStep = step
  },
  setStepData(state, { stepIndex, stepData }) {
    let step = state.steps.find(s => s.index == stepIndex)
    step.stepData = stepData
  },
  updateValidStep(state, { stepIndex, valid }) {
    let step = state.steps.find(s => s.index == stepIndex)
    step.valid = valid
    // PARCHE (habria que manejar el current step con un getter y un index en lugar de la referencia al objeto)
    if (stepIndex == state.currentStep?.index) state.currentStep = step
  },
  setFormulario(state, formulario) {
    state.formulario = formulario
  },
  updateCajaForm(state, data) {
    state.formulario.formCaja.nro_comprobante = data.comprobante.numero_comprobante
    state.formulario.formCaja.descripcion = data.comprobante.descripcion
    state.formulario.formCaja.fecha_vencimiento = data.comprobante.fecha_vencimiento
    state.formulario.formCaja.monto = data.comprobante.monto
    state.formulario.tipoDeuda = data.tipoDeuda
    state.formulario.categoriaId = data.categoriaId
  },
  addRequestData(state, requestData) {
    Object.assign(state.altaDeudaRequest, requestData)
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async altaDeuda({ state }, { cuitCuil, portalPagos }) {
    return await portalPagos.postDeuda(cuitCuil, state.altaDeudaRequest)
  },

  resetState({ commit }) {
    commit('resetState')
  },
  async actualizarCajaForm({ commit }, data) {
    commit('updateCajaForm', data)
  },
}

const getters = {
  datosFormulario: state => {
    return {
      resumen: state.formulario.resumenForm,
      values: state.steps[0].stepData,
    }
  },
  datosComprobante: state => {
    return {
      formulario: state.steps[0].stepData,
      medioPago: state.steps[1].stepData,
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
